var ScoreMonitor = function(options) {
    var self = this;

    this.options = $.extend({
        charts: {}
    }, options);

    this.loadScoresReq   = {};
    this.saveForecastReq = {};
};

ScoreMonitor.prototype.loadScores = function() {
	if (typeof this.loadScoresReq.abort == 'function') {
		this.loadScoresReq.abort();
	}

	this.loadScoresReq = $.get('/site/ajax/get_kpi_scores.php', function(data) {
		$.each(data.kpi_groups, function(kpi_nr, kpi_data) {
			var $menu_item = $('.score-button[data-menu-button="kpi_' + kpi_nr + '"]');

			$menu_item.find('.progress-result').css('width', kpi_data.totals.result.score_perc + '%');
			$menu_item.find('.progress-forecast').css('width', kpi_data.totals.forecast.score_perc + '%');

			$.each(kpi_data.warnings, function(type, type_warnings) {
				var $warnings = $('.kpi-warning[data-type="' + type + '"][data-kpi="' + kpi_nr + '"]');

				if (type_warnings.length > 0) {
					$warnings.html('');

					$.each(type_warnings, function(warning_key, type_warning) {
						$warnings.append(type_warning + '<br />');
					});

					$warnings.slideDown('fast');

				} else {
					$warnings.slideUp('fast');
				}
			});

			$menu_item.find('.counter-kpi-forecast').counter({
				start: parseFloat($menu_item.find('.counter-kpi-forecast').data('counter-current')),
				end: kpi_data.totals.forecast.score,
				duration: 500,
				decimals: 0
			});

			$menu_item.find('.counter-kpi-result').counter({
				start: parseFloat($menu_item.find('.counter-kpi-result').data('counter-current')),
				end: kpi_data.totals.result.score,
				duration: 500,
				decimals: 0
			});

            $('.scores-totals.result').attr('data-qualifiers', data.qualifiers ? 1 : 0);

			var $counterResult   = $('.counter-kpi-' + kpi_nr + '-result');
			var $counterForecast = $('.counter-kpi-' + kpi_nr + '-forecast');

			$counterResult.counter({
				start: parseFloat($counterResult.data('counter-current')),
				end: kpi_data.totals.result.score,
				duration: 500,
				decimals: 0
			});

			$counterForecast.counter({
				start: parseFloat($counterForecast.data('counter-current')),
				end: kpi_data.totals.forecast.score,
				duration: 500,
				decimals: 0
			});
		});

		$.each(data.kpi_subgroups, function(subgroup_name, subgroup_data) {
			var $counterResult   = $('.counter-kpi-' + subgroup_name + '-result');
			var $counterForecast = $('.counter-kpi-' + subgroup_name + '-forecast');

			$counterResult.counter({
				start: parseFloat($counterResult.data('counter-current')),
				end: subgroup_data.totals.result.score,
				duration: 500,
				decimals: 0
			});

			$counterForecast.counter({
				start: parseFloat($counterForecast.data('counter-current')),
				end: subgroup_data.totals.forecast.score,
				duration: 500,
				decimals: 0
			});
		});

        $('.counter-result').data('counter-end', data.totals.result.score).counter({
            start: parseFloat($('.counter-result').data('counter-current')),
            end: data.totals.result.score,
            duration: 500,
            decimals: 0
        });

        $('.counter-forecast').data('counter-end', data.totals.forecast.score).counter({
            start: parseFloat($('.counter-forecast').data('counter-current')),
            end: data.totals.forecast.score,
            duration: 500,
            decimals: 0
        });

		setGrayGlassHeight(data.totals.forecast.score_perc);
        setGlassHeight(data.totals.result.score_perc);
        setCurrentPrize();

        // $('.progress-levels .progress-level').each(function() {
        // 	if ($(this).data('score') <= data.totals.forecast.score) {
        // 		$(this).addClass('active-forecast');
		// 	} else {
        // 		$(this).removeClass('active-forecast');
		// 	}
		//
        // 	if ($(this).data('score') <= data.totals.result.score) {
        // 		$(this).addClass('active-result');
		// 	} else {
        // 		$(this).removeClass('active-result');
		// 	}
		// });
	});
};

ScoreMonitor.prototype.saveForecast = function(kpi_key, value) {
	var self = this;

	if (typeof this.saveForecastReq.abort == 'function') {
		this.saveForecastReq.abort();
	}

	this.saveForecastReq = $.post('/site/ajax/save_kpi_forecast.php', {
		kpi_key: kpi_key,
		value: value
	}, function() {
		self.loadScores();
		showTotalScores('forecast');
	});
};
